import { Ellipsis } from 'lucide-react';
import { useState } from 'react';
import { t } from '../../i18n';
import { Drawer } from '../feedback/Sheet';
import type { NavItemDef } from '../types';
import { NavItem, NavItemContent, navItemClassName } from './NavItem';

type MoreMenuProps = { items: NavItemDef[]; activeNavId?: string };

// Diğer in the bottom bar: the areas that do not fit it, in a bottom drawer (design system §4, merchant screens §1).
export function MoreMenu({ items, activeNavId }: MoreMenuProps) {
  const [open, setOpen] = useState(false);
  const active = items.some((item) => item.id === activeNavId);
  return (
    <>
      <button
        type="button"
        aria-haspopup="dialog"
        aria-expanded={open}
        data-active={active || undefined}
        className={navItemClassName('bottom', active)}
        onClick={() => setOpen(true)}
      >
        <NavItemContent icon={Ellipsis} label={t('nav.more')} variant="bottom" active={active} />
      </button>
      <Drawer open={open} onOpenChange={setOpen} title={t('nav.more')}>
        <ul className="flex flex-col gap-1 pb-4">
          {items.map((item) => (
            <li key={item.id}>
              <NavItem
                item={item}
                variant="sidebar"
                active={item.id === activeNavId}
                onClick={() => setOpen(false)}
              />
            </li>
          ))}
        </ul>
      </Drawer>
    </>
  );
}
